import React from "react";
import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { Show } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import SiteLayout from "@/components/site/SiteLayout";
import SiteGate from "@/components/site/SiteGate";
import Home from "@/pages/public/Home";
import Services from "@/pages/public/Services";
import About from "@/pages/public/About";
import Rewards from "@/pages/public/Rewards";
import Book from "@/pages/public/Book";
import Contact from "@/pages/public/Contact";
import SignAgreement from "@/pages/public/SignAgreement";
import { SignInPage, SignUpPage } from "@/pages/public/AuthPages";
import DashLayout from "@/pages/dashboard/DashLayout";
import Overview from "@/pages/dashboard/Overview";
import Bookings from "@/pages/dashboard/Bookings";
import BookingDetail from "@/pages/dashboard/BookingDetail";
import NewBooking from "@/pages/dashboard/NewBooking";
import Calculator from "@/pages/dashboard/Calculator";
import Customers from "@/pages/dashboard/Customers";
import Agreements from "@/pages/dashboard/Agreements";
import Settings from "@/pages/dashboard/Settings";

function OwnerGate() {
  return (
    <>
      <Show when="signed-in"><DashLayout /></Show>
      <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteGate>
        <ClerkAuthProvider>
          <Toaster theme="dark" position="top-right" richColors />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/royal-rewards" element={<Rewards />} />
              <Route path="/book" element={<Book />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/sign/:token" element={<SignAgreement />} />
            <Route path="/sign-in/*" element={<SignInPage />} />
            <Route path="/sign-up/*" element={<SignUpPage />} />
            <Route path="/dashboard" element={<OwnerGate />}>
              <Route index element={<Overview />} />
              <Route path="bookings" element={<Bookings />} />
              <Route path="bookings/:id" element={<BookingDetail />} />
              <Route path="new" element={<NewBooking />} />
              <Route path="calculator" element={<Calculator />} />
              <Route path="customers" element={<Customers />} />
              <Route path="agreements" element={<Agreements />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ClerkAuthProvider>
        </SiteGate>
      </BrowserRouter>
    </div>
  );
}
